import { Link } from 'react-router-dom';
import FadeInSection from '../../../components/feature/FadeInSection';

const LINE_URL = 'https://lin.ee/PNbhQI0';

export default function EnrollmentCTASection() {
  return (
    <section className="section-padding" style={{ background: '#f2f8f4' }}>
      <div className="content-width">
        <FadeInSection className="text-center">
          <p
            className="inline-block px-4 py-1 rounded-full mb-5 text-sm font-bold"
            style={{ background: '#fff', color: '#5a9e6f', border: '1px solid #5a9e6f' }}
          >
            まずはご予約から
          </p>
          <h2 style={{ color: '#4a3728' }} className="mb-5">
            無料相談のご予約はこちら
          </h2>
          <p style={{ color: '#6b5a4e', fontSize: '17px', lineHeight: '1.9' }} className="mb-10 mx-auto max-w-xl">
            完全予約制です。お電話またはLINE・メールにて<br className="hidden sm:block" />
            お気軽にご連絡ください。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center flex-wrap">
            <a
              href="tel:0345008399"
              style={{
                background: '#8b4513',
                color: '#fff',
                borderRadius: '8px',
                padding: '16px 36px',
                fontSize: '17px',
                fontWeight: '700',
              }}
              className="whitespace-nowrap hover:opacity-90 transition-opacity flex items-center gap-2"
            >
              <i className="ri-phone-line text-xl"></i>
              03-4500-8399
            </a>
            <a
              href={LINE_URL}
              target="_blank"
              rel="nofollow noopener noreferrer"
              style={{
                background: '#06C755',
                color: '#fff',
                borderRadius: '8px',
                padding: '16px 36px',
                fontSize: '17px',
                fontWeight: '700',
              }}
              className="whitespace-nowrap hover:opacity-90 transition-opacity flex items-center gap-2"
            >
              <i className="ri-line-fill text-xl"></i>
              LINEで無料相談する
            </a>
            <Link
              to="/contact"
              style={{
                background: '#fff',
                color: '#8b4513',
                borderRadius: '8px',
                padding: '16px 36px',
                fontSize: '17px',
                fontWeight: '700',
                border: '2px solid #d4a574',
              }}
              className="whitespace-nowrap hover:bg-[#fff8f2] transition-colors flex items-center gap-2"
            >
              <i className="ri-mail-send-line text-xl"></i>
              お問い合わせフォーム
            </Link>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
